import React from "react";

const RelatedRecordsField = ({ field, onOpenLinkedRecord }) => {
  if (!field?.displayValue?.groups?.length) {
    return <span className="text-slate-500">N/A</span>;
  }

  const mode = field.displayValue.mode || "records";
  const groups = field.displayValue.groups;

  if (mode === "coverage") {
    return (
      <div className="flex w-full flex-col gap-2 md:max-w-[70%] md:items-end">
        {groups.map((group) => (
          <div
            key={`coverage-${group.datasetKey}`}
            className="w-full rounded-lg border border-slate-700/80 bg-slate-950/50 px-3 py-2 md:max-w-[24rem]"
          >
            <p className="text-sm font-semibold text-slate-100">{group.label}</p>
            <p className="mt-1 text-xs text-slate-400">
              {group.docs} related docs
              {group.mentions ? ` • ${group.mentions} mentions` : ""}
            </p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-3 md:max-w-[70%] md:items-end">
      {groups.map((group) => (
        <div
          key={`related-${group.datasetKey}`}
          className="w-full rounded-lg border border-slate-700/80 bg-slate-950/50 px-3 py-3 md:max-w-[30rem]"
        >
          <p className="text-sm font-semibold text-slate-100">
            {group.datasetLabel} ({group.count})
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            {group.items.map((item) => (
              <button
                key={`${group.datasetKey}-${item.recordId}`}
                type="button"
                onClick={() => onOpenLinkedRecord?.(group.datasetKey, item.recordId)}
                className="inline-flex items-center gap-1 rounded-full border border-sky-500/40 px-2.5 py-1 text-xs font-medium text-sky-300 transition-colors hover:border-sky-400 hover:text-sky-200"
              >
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RelatedRecordsField;
